import React from "react";
import { useSelector } from "react-redux";
import { convertThenFormat } from "../common-data/Converts";
import DashboardCard from "../../pages/home/common/DashboardCard";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import { ptTrials, trial_added_from } from "../common-data/DropdowData";

const PTTrackCards = (props) => {
  const {
    setShowTable,
    ptDatas,
    setFilters,
    isAddedByMe,
    isTrainer,
    setIsAddedByMe,
    addedByMe,
    isReceptionist,
    isFitnessManager,
    activeKey,
    setActiveKey,
  } = props || {};
  const { ptCardData } = ptDatas || {};
  const { totalSubs, totalHandover, totalInitiated } = addedByMe || {};

  const { ptTrialStatsLoading } = useSelector((state) => state.api);

  const order = [
    "allSubsCount",
    "added_from_engagement",
    "total_handover_pending",
    "total_handover_completed",
    "total_pending_today",
    "total_completed_today",
    "total_pending",
    "total_completed",
    "trial_done_cnvrtd",
    "trial_notdone_cnvrtd",
    "total_pt_prspct_value",

    "threeday_converted_amount",

    // "hot_prspct",
    // "semi_hot_prspct",
    // "warm_prspct",
    // "cold_prspct",
    // "closed_cnvrtd_prspct",
    // "closed_not_cnvrtd_prspct",
    // "not_specified_prspct",
    // "trnr_intro_pending",
    // "trnr_intro_completed",
  ];

  const orderTrainer = [
    "total",
    "added_from_engagement",
    "total_pending",
    "total_completed",

    "trial_done_cnvrtd",
    "trial_notdone_cnvrtd",
    "total_pt_prspct_value",

    "threeday_converted_amount",

    // "hot_prspct",
    // "semi_hot_prspct",
    // "warm_prspct",
    // "cold_prspct",
    // "closed_cnvrtd_prspct",
    // "closed_not_cnvrtd_prspct",
    // "not_specified_prspct",

    // "total_pending_today",
    // "total_completed_today",
  ];

  const iterableVardObject = isTrainer ? orderTrainer : order;

  const labelMap = {
    allSubsCount: "total subscriptions",
    added_from_engagement: "Added from Engagement Form",
    total_completed: "PT consultation Completed (Not Converted)",
    total_pending: "PT consultation Pending",
    total_converted: "PT consultation Converted",
    total_handover_completed: "Front Desk Handover Completed",
    total_handover_pending: "Front Desk Handover Pending",
    total_handover_converted: "Front Desk Handover Converted",
    total_handover: "Front Desk Handover All (Pending + Completed)",
    trial_done_cnvrtd: "PT consultation done And Converted",
    trial_notdone_cnvrtd: "PT consultation not done And Converted",
    total_pt_prspct_value: "Total PT Prospect",
    hot_prspct: "Hot Prospect",
    semi_hot_prspct: "Semi Hot Prospect",
    warm_prspct: "Warm Prospect",
    cold_prspct: "Cold Prospect",
    closed_cnvrtd_prspct: "Closed And Converted Prospect",
    closed_not_cnvrtd_prspct: "Closed And Not Converted Prospect",
    not_specified_prspct: "Prospect Not Specified",
    total_pending_today: "PT consultation Pending Today",
    total_completed_today: "PT consultation Completed Today",
    trnr_intro_pending: "Trainer Intro Pending",
    trnr_intro_completed: "Trainer Intro Completed",
    threeday_converted_amount: "3 Day Trial",
  };

  const getCardLabel = (key) => labelMap[key] || `${key.replace(/_/g, " ")}`;

  const handleCardClick = (key) => {
    setShowTable(true);

    console.log("key", key);

    if (key === "threeday_converted_amount") {
      setActiveKey(key);
      setFilters((prevFilters) => ({
        ...prevFilters,
        selectedCard: key,
        selectedPTTrial: ptTrials[1],

        isFutureSubscription: false
      }));
    } else if (key.includes("handover")) {
      setActiveKey(key);
      setFilters((prevFilters) => ({
        ...prevFilters,
        selectedCard: key,
        selectedHandoverStatus: {
          label:
            key === "total_handover_completed"
              ? "Completed Handover"
              : key === "total_handover_converted"
              ? "Converted Handover"
              : key === "total_handover_pending"
              ? "Pending Handover"
              : key === "total_handover"
              ? "Total Handover"
              : "",
          value:
            key === "total_handover_completed"
              ? "handover_completed"
              : key === "total_handover_converted"
              ? "handover_converted"
              : key === "total_handover_pending"
              ? "handover_pending"
              : key === "total_handover"
              ? "handover_all"
              : "",
        },

        isFutureSubscription: false
      }));
    } else if (key.includes("total_pt_prspct_value")) {
      setActiveKey(key);
      setFilters((prevFilters) => ({
        ...prevFilters,
        selectedCard: key,
        selPTProspect: {
          label: "Total PT Prospect",
          value: 1,
        },

        isFutureSubscription: false
      }));
    } else if (
      key.includes("trnr_intro_pending") ||
      key.includes("trnr_intro_completed")
    ) {
      setActiveKey(key);
      setFilters((prevFilters) => ({
        ...prevFilters,
        selectedCard: key,
        selTrainerIntro: {
          label:
            key === "trnr_intro_pending"
              ? "Trainer Intro Pending"
              : key === "trnr_intro_completed"
              ? "Trainer Intro Completed"
              : key,
          value:
            key === "trnr_intro_pending"
              ? "pending"
              : key === "trnr_intro_completed"
              ? "completed"
              : key,
        },

        isFutureSubscription: false
      }));
    } else if (key.includes("_prspct")) {
      setActiveKey(key);
      setFilters((prevFilters) => ({
        ...prevFilters,
        selectedCard: key,
        selProspectStatus: {
          label:
            key === "hot_prspct"
              ? "Hot Prospect"
              : key === "semi_hot_prspct"
              ? "Semi Hot Prospect"
              : key === "warm_prspct"
              ? "Warm Prospect"
              : key === "cold_prspct"
              ? "Cold Prospect"
              : key === "closed_cnvrtd_prspct"
              ? "Closed And Converted Prospect"
              : key === "closed_not_cnvrtd_prspct"
              ? "Closed And Not Converted Prospect"
              : key === "not_specified_prspct"
              ? "Prospect Not Specified"
              : key?.replace(/_/g, " "),
          value:
            key === "hot_prspct"
              ? "hot"
              : key === "semi_hot_prspct"
              ? "semi_hot"
              : key === "warm_prspct"
              ? "warm"
              : key === "cold_prspct"
              ? "cold"
              : key === "closed_cnvrtd_prspct"
              ? "closed_cnvrtd"
              : key === "closed_not_cnvrtd_prspct"
              ? "closed_not_cnvrtd"
              : key === "not_specified_prspct"
              ? "not_specified_prspct"
              : key?.replace(/_/g, " "),
        },

        isFutureSubscription: false
      }));
    } else if (key === "added_from_engagement") {
      setActiveKey(key);
      setFilters((prevFilters) => ({
        ...prevFilters,
        selectedCard: key,
        selTrialAddedFrom: trial_added_from[0],

        isFutureSubscription: false
      }));
    } else {
      setActiveKey(key);
      setFilters((prevFilters) => ({
        ...prevFilters,
        selectedCard: key,
        selectedPTTrialStatus: key !== "allSubsCount" && {
          label:
            key === "total_completed"
              ? "Completed PT consultation"
              : key === "total_converted"
              ? "Converted PT consultation"
              : key === "total_pending"
              ? "Pending PT consultation"
              : key === "total"
              ? "Total PT consultation"
              : key === "trial_done_cnvrtd"
              ? "PT consultation done And Converted"
              : key === "trial_notdone_cnvrtd"
              ? "PT consultation not done And Converted"
              : key === "total_pending_today"
              ? "PT consultation Pending Today"
              : key === "total_completed_today"
              ? "PT consultation Completed Today"
              : key,
          value:
            key === "total_completed"
              ? "completed"
              : key === "total_converted"
              ? "converted"
              : key === "total_pending"
              ? "pending"
              : key === "total"
              ? "all"
              : key === "trial_done_cnvrtd"
              ? "trial_done_cnvrtd"
              : key === "trial_notdone_cnvrtd"
              ? "trial_notdone_cnvrtd"
              : key,
        },

        isFutureSubscription: false,
      }));
    }
  };

  return (
    <>
      {ptTrialStatsLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <div className="cards-container cards-grid-container grid-4 mt-2rem">
          {iterableVardObject?.length > 0 &&
            iterableVardObject.map((key, index) => (
              <React.Fragment key={index}>
                {
                  <DashboardCard
                    tagName={key}
                    cardLabel={getCardLabel(key)}
                    value={`${
                      key === "total_pt_prspct_value"
                        ? `₹${convertThenFormat(ptCardData?.[key] || 0)} (${
                            ptCardData?.["total_pt_prspct"] || 0
                          })`
                        : key === "threeday_converted_amount"
                        ? `₹${convertThenFormat(ptCardData?.[key] || 0)} (${
                            ptCardData?.["total_threeday_assigned"] || 0
                          })`
                        : ptCardData?.[key] || 0
                    }`}
                    onClickCard={() => handleCardClick(key)}
                    cardIndex={index}
                    isActiveCard={activeKey === key}
                    isPTTrack={true}
                  />
                }
              </React.Fragment>
            ))}

          {(isReceptionist || isFitnessManager) && (
            <>
              <DashboardCard
                tagName={"subs_added_by_me"}
                cardLabel={`Subscription Added By Me`}
                value={convertThenFormat(totalSubs || 0)}
                onClickCard={() => {
                  setIsAddedByMe("subs_added_by_me");
                  setShowTable(true);
                }}
                cardIndex={"subs_added_by_me"}
                isActiveCard={`${
                  isAddedByMe === "subs_added_by_me" ? "active" : ""
                }`}
                isPTTrack={true}
              />

              <DashboardCard
                tagName={"hand_added_by_me"}
                cardLabel={`Handover Added By Me`}
                value={convertThenFormat(totalHandover || 0)}
                onClickCard={() => {
                  setIsAddedByMe("hand_added_by_me");
                  setShowTable(true);
                }}
                cardIndex={"hand_added_by_me"}
                isActiveCard={`${
                  isAddedByMe === "hand_added_by_me" ? "active" : ""
                }`}
                isPTTrack={true}
              />
            </>
          )}

          {isFitnessManager && (
            <>
              <DashboardCard
                tagName={"trial_initiated_by_me"}
                cardLabel={`Trial Initiated By Me`}
                value={convertThenFormat(totalInitiated || 0)}
                onClickCard={() => {
                  setIsAddedByMe("trial_initiated_by_me");
                  setShowTable(true);
                }}
                cardIndex={"trial_initiated_by_me"}
                isActiveCard={`${
                  isAddedByMe === "trial_initiated_by_me" ? "active" : ""
                }`}
                isPTTrack={true}
              />
            </>
          )}
        </div>
      )}
    </>
  );
};

export default PTTrackCards;
